import axios from "axios";
import { base_url } from "../../utils/baseUrl";
import { config } from "../../utils/axiosconfig";

const getNewsCategories = async () => {
  const response = await axios.get(`${base_url}country/countryData`);
  
  return response.data;
  
};
const createNewsCategory = async (bcat) => {
  const id = bcat.countryNamee;
  const idd = bcat.categoryName;
  delete bcat.countryNamee;
  delete bcat.categoryName;
  const response = await axios.post(`${base_url}country/countryData/${id}/${idd}`, bcat, config);

  return response.data;
};
const updateNewsCategory = async (id, secondId ,subcollectionId , NewsCatData) => {
  delete NewsCatData.isWebsiteRedirect;
  delete NewsCatData.uploadedTime;

  const response = await axios.put(
    `${base_url}country/countryData/${subcollectionId}/city/${secondId}/countryData/${id}`,
    { NewsCatData }
  );

  return response.data;
};
const getNewsCategory = async (id,cityId,subcollectionId) => {
  const response = await axios.get(`${base_url}country/countryData/${subcollectionId}/city/${cityId}/countryData/${id}`, config);
  return response.data;

};

const deleteNewsCategory = async (id, secondId, subcollectionId) => {
  const response = await axios.delete(`${base_url}country/countryData/${id}/city/${secondId}/countryData/${subcollectionId}`, config);

  return response.data;
};
const bCategoryService = {
  getNewsCategories,
  createNewsCategory,
  deleteNewsCategory,
  getNewsCategory,
  updateNewsCategory,
};

export default bCategoryService;
